import styled from 'styled-components';

export const CollectionRoot = styled('section')`
  padding-top: 20px;

  .heading {
    font-size: 48px;
    text-align: center;
  }

  .info {
    font-size: 30px;
    text-align: center;

    a {
      margin-left: 10px;
      color: #ff4d6e;
      text-decoration: underline;
    }
  }
`;

export const TabButtons = styled('div')`
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
  button {
    &:hover {
      color: white;
      background-color: #ffffff4f;
      border-color: #ffffff4f;
    }
    &:first-child {
      border: 1px solid #fff;
      border-radius: 4px 0 0 4px;
      border-right: none;
    }
    &:last-child {
      border: 1px solid #fff;
      border-radius: 0 4px 4px 0;
      border-left: none;
    }
  }
`;
export const ClaimButton = styled('button')`
  background: #fff;
  color: #0f0f0f;
  border: none;
  cursor: pointer;
  padding: 18px;
  border-radius: 10px;
  font-size: 1.2rem;
  min-width: 320px;
  margin-top: 40px;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: #d5d5d5;
  }
`;

export const CollectionMain = styled('div')`
  padding: 50px 0;
`;

export const GridContainer = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 100px;
  margin-top: 30px;
`;

export const ConnectInfo = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
`;

// @media screen and (max-width: 1024px) {
//   padding: 5.5rem 0 3rem;
// }
